import { render, staticRenderFns } from "./SQuesThree.vue?vue&type=template&id=2a18af4e&scoped=true&"
import script from "./SQuesThree.vue?vue&type=script&lang=js&"
export * from "./SQuesThree.vue?vue&type=script&lang=js&"
import style0 from "./SQuesThree.vue?vue&type=style&index=0&id=2a18af4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a18af4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
